import { ExchangeRes } from '@kr/components/exchange/models';

export const mockExchangeRes: ExchangeRes = {
  operationId: '123',
};
